import React, { useState } from "react";
import { Dashboard as DashboardLayout } from "layouts";
import {
  RowDetailState,
  PagingState,
  IntegratedPaging,
  SearchState,
  IntegratedFiltering,
} from "@devexpress/dx-react-grid";
import {
  Grid as DataGrid,
  Table,
  TableHeaderRow,
  TableRowDetail,
  PagingPanel,
  Toolbar,
  SearchPanel,
} from "@devexpress/dx-react-grid-material-ui";
import { withRouter } from "react-router";
import compose from "recompose/compose";
import PropTypes from "prop-types";
import {
  Typography,
  withStyles,
  Grid,
  Paper,
  CircularProgress,
  Button,
} from "@material-ui/core";
import {
  ADD_NEW_REQUEST_COMMENT,
  ADD_NEW_REQUEST_COMMENT_NOTIFICATION,
  GET_MY_DEALERS_SALE,
  GET_NEW_DEALER_REQUEST_SALES,
} from "../queries";
import { useQuery, useSubscription } from "@apollo/client";
import auth from "Auth";
import { makeStyles } from "@material-ui/core/styles";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import Chip from "@material-ui/core/Chip";
import MenuItem from "@material-ui/core/MenuItem";
import NewDealerDetails from "./NewDealerDetails";
import TextField from "@material-ui/core/TextField";
import { Mutation, Query } from "react-apollo";
import { toast } from "react-toastify";
import { getAllUsers } from "queries";

const styles = (theme) => ({
  button: {
    margin: theme.spacing(),
  },
  input: {
    display: "none",
  },
  root: {
    padding: theme.spacing(),
  },
  item: {
    height: "100%",
  },
  marginFix: {
    marginTop: 19,
    marginBottom: 10,
    marginLeft: 5,
    marginRight: 5,
  },
  gridContainer: {
    display: "flex",
    flexDirection: "column",
  },
});
function DealerRequest(props) {
  const { classes } = props;
  const useStyles = makeStyles((theme) => ({
    formControl: {
      margin: theme.spacing(1),
      minWidth: 200,
      maxWidth: 300,
    },
    chips: {
      display: "flex",
      flexWrap: "wrap",
    },
    chip: {
      margin: 2,
    },
    noLabel: {
      marginTop: theme.spacing(3),
    },
  }));
  const [columns] = useState([
    { name: "request_date", title: "Date Added" },
    {
      name: "company",
      title: "Dealer Company",
      getCellValue: (row) => row?.profile?.company || "",
    },
    {
      name: "brand",
      title: "Brand",
      getCellValue: (row) =>
        row?.carolinaskiff
          ? "Carolina Skiff"
          : row?.seachaser
          ? "Sea Chaser"
          : "",
    },
    {
      name: "email",
      title: "Email",
      getCellValue: (row) => row?.profile?.email || "",
    },
  ]);

  const brandOptions = {
    "Carolina Skiff": "carolinaskiff",
    "Sea Chaser": "seachaser",
    "Fun Chaser": "has_funchaser",
  };

  const [selectedField, setSelectedField] = useState("Date Added");
  const [selectedFieldMultiple, setSelectedFieldMultiple] = useState(() => []);

  const [searchValue, setSearchValue] = useState("");

  const [isSubmit, setIsSubmit] = useState(false);

  const { data: salesData, loading: salesLoading } = useQuery(
    GET_MY_DEALERS_SALE,
    {
      notifyOnNetworkStatusChange: true,
      variables: { profile_id: auth.getSub() },
      fetchPolicy: "cache-and-network",
    }
  );

  const { loading, data, error } = useSubscription(
    GET_NEW_DEALER_REQUEST_SALES,
    {
      notifyOnNetworkStatusChange: true,
      skip: salesData === undefined,
      variables: {
        profileIds: [
          ...(salesData?.sales_assign?.map((e) => e?.assign_user_id) || []),
          auth.getSub(),
        ],
      },
      fetchPolicy: "cache-and-network",
    }
  );

  const FieldDropdown = ({ fields, selectedField, onSelectField }) => (
    <select
      value={selectedField}
      onChange={(e) => onSelectField(e.target.value)}
    >
      {fields?.map((field) => (
        <option key={field} value={field}>
          {field}
        </option>
      ))}
    </select>
  );

  const FieldMultipleDropdown = ({ fields, selectedField, onSelectField }) => {
    const classes = useStyles();

    const handleChange = (event) => {
      const values = event.target.value;
      onSelectField(values);
    };

    return (
      <FormControl className={classes.formControl}>
        <InputLabel id="mutiple-chip-label">Brand</InputLabel>
        <Select
          labelId="mutiple-chip-label"
          id="mutiple-chip-select"
          multiple
          value={selectedFieldMultiple || []}  // Ensure it's always an array
          onChange={handleChange}
          renderValue={(selected) => (
            <div className={classes.chips}>
              {selected?.map((value) => (
                <Chip key={value} label={value} className={classes.chip} />
              ))}
            </div>
          )}
        >
          {fields?.map((name) => (
            <MenuItem key={name} value={name}>
              {name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    );
  };

  const DealerCompanyDropdown = ({ fields, selectedField, onSelectField }) => {
    const classes = useStyles();

    const handleChange = (event) => {
      const values = event.target.value;
      onSelectField(values);
    };

    return (
      <FormControl className={classes.formControl}>
        <InputLabel id="dealer-company-label">Dealer Company</InputLabel>
        <Select
          labelId="dealer-company-label"
          id="dealer-company-select"
          multiple
          value={selectedField}
          onChange={handleChange}
          renderValue={(selected) => (
            <div className={classes.chips}>
              {selected.map((value) => (
                <Chip key={value} label={value} className={classes.chip} />
              ))}
            </div>
          )}
        >
          {fields.map((name) => (
            <MenuItem key={name} value={name}>
              {name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    );
  };

  const handleFieldChange = (selectedField) => {
    setSelectedField(selectedField);
    setSearchValue("");
    setSelectedFieldMultiple([]);
  };

  const handleFieldChangeMultiple = (selectedField) => {
    setSelectedFieldMultiple(selectedField);
    setSearchValue("");
  };

  if (error) return <p>Error {JSON.stringify(error)}</p>;

  const filteredRows = data?.new_dealer_requests?.filter((row) => {
    let name;

    if (selectedField === "Date Added") {
      name =
        row?.[
          columns.find((e) => e.title === selectedField)?.name
        ]?.toLowerCase();
    } else if (
      selectedField !== "Brand" &&
      selectedField !== "Dealer Company"
    ) {
      name =
        row?.profile?.[
          columns.find((e) => e.title === selectedField)?.name
        ]?.toLowerCase();
    } else if (selectedField === "Brand") {
      return (
        selectedFieldMultiple?.length === 0 ||
        selectedFieldMultiple?.some(
          (brandName) => row?.[brandOptions[brandName]]
        )
      );
    } else if (selectedField === "Dealer Company") {
      return (
        selectedFieldMultiple.length === 0 ||
        selectedFieldMultiple.includes(row?.profile?.company)
      );
    }

    const searchText = searchValue?.toLowerCase().trim();
    return name?.includes(searchText);
  });

  const changeSearchValue = (newValue) => {
    setSearchValue(newValue);
  };

  const RowDetail = ({ row }) => {
    const [comment, setComment] = useState("");
    const [errors, setErrors] = useState(false);

    const handleChanges = (event) => {
      const inputText = event.target.value;
      if (inputText.length <= 700) {
        setComment(inputText);
        setErrors(false);
      } else {
        setErrors("Maximum 700 words allowed");
      }
    };

    return (
      <div>
        <div style={{ padding: "10px" }}>
          <Grid item xs={12} sm={12} md={12}>
            <NewDealerDetails
              row={row}
              comment={comment}
              setComment={setComment}
              errors={errors}
              setErrors={setErrors}
              setIsSubmit={setIsSubmit}
              isSubmit={isSubmit}
            />
            <TextField
              id="comments"
              name="comments"
              label="Add Comment Here"
              multiline
              rows="4"
              variant="outlined"
              onChange={(e) => handleChanges(e)}
              margin="normal"
              value={comment || ""}
              error={errors}
              helperText={errors}
              style={{
                width: "100%",
                marginTop: "0px",
              }}
            />
          </Grid>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Query query={getAllUsers}>
              {({ data: profileData, loading, error }) => {
                if (loading) return <p>Loading...</p>;
                if (error) return <p>Error</p>;

                return (
                  <Mutation
                    mutation={ADD_NEW_REQUEST_COMMENT}
                    onError={() => setIsSubmit(false)}
                    onCompleted={() => {
                      setComment("");
                      setIsSubmit(false);
                    }}
                  >
                    {(addComment, { data, loading, called, error }) => {
                      if (error) {
                        toast.error(error?.graphQLErrors?.[0]?.message);
                      }

                      return (
                        <Mutation
                          mutation={ADD_NEW_REQUEST_COMMENT_NOTIFICATION}
                          onError={() => setIsSubmit(false)}
                          onCompleted={() => {
                            setComment("");
                            setIsSubmit(false);
                          }}
                        >
                          {(
                            addNotification,
                            { data, loading, called, error }
                          ) => {
                            if (error) {
                              toast.error(error?.graphQLErrors?.[0]?.message);
                            }

                            return (
                              <Button
                                color="primary"
                                variant="contained"
                                type="submit"
                                className="save_btn"
                                disabled={isSubmit}
                                onClick={() => {
                                  if (comment?.trim()?.length === 0) {
                                    setErrors("Please enter comment");
                                  } else {
                                    setIsSubmit(true);
                                    addComment({
                                      variables: {
                                        objects: {
                                          comment: comment,
                                          profile_id: auth.getSub(),
                                          new_dealer_requests_id: row?.id,
                                        },
                                      },
                                    }).then(() => {
                                      addNotification({
                                        variables: {
                                          objects: profileData?.profiles?.map(
                                            (item) => ({
                                              profile_id: item?.profile_id,
                                              send_by: auth.getSub(),
                                              title:
                                                "You have received 1 comment for New Dealer Request",
                                              type: "new_dealer_request",
                                              message: comment,
                                              redirect_link:"/admin-new-dealer-requests",
                                              user_data: JSON.stringify({
                                                new_dealer_email:
                                                  row?.business_email,
                                                new_dealer_name:
                                                  row?.legal_name,
                                                profile_email: item?.email,
                                                send_by_email: auth.getEmail(),
                                                send_by_name:
                                                  auth.getNickName(),
                                              }),
                                            })
                                          ),
                                        },
                                      });
                                    });
                                  }
                                }}
                              >
                                Save
                              </Button>
                            );
                          }}
                        </Mutation>
                      );
                    }}
                  </Mutation>
                );
              }}
            </Query>
          </div>
        </div>
      </div>
    );
  };

  return (
    <DashboardLayout title="My Dealers" className="myDealers">
      <div className={classes.root + " sectionContainer"}>
        <Typography gutterBottom variant="h4" className="title">
          <span className="dealer_title">Dealer Request</span>
        </Typography>

        <Paper className={classes.paper} style={{ margin: "3em" }}>
          <Grid container>
            <Grid item xs align="center">
              <div className={classes.gridContainer}>
                {!loading && !salesLoading ? (
                  <DataGrid rows={filteredRows || []} columns={columns}>
                    <SearchState
                      value={searchValue}
                      onValueChange={changeSearchValue}
                    />
                    <PagingState defaultCurrentPage={0} pageSize={10} />
                    <IntegratedFiltering />
                    <IntegratedPaging />
                    <RowDetailState defaultExpandedRowIds={[0]} />
                    <Table />
                    <TableHeaderRow />
                    <PagingPanel />
                    <TableRowDetail contentComponent={RowDetail} />
                    <Toolbar />

                    {/* dropdown */}
                    <div
                      className={`tableFilter ${
                        selectedField === "Brand" ||
                        selectedField === "Dealer Company"
                          ? "selectbrand"
                          : ""
                      }`}
                    >
                      <div className="wrapper">
                        <FieldDropdown
                          fields={columns.map((column) => column.title)}
                          selectedField={selectedField}
                          onSelectField={handleFieldChange}
                        />
                        {selectedField === "Brand" ? (
                          <FieldMultipleDropdown
                            fields={Object.keys(brandOptions)}
                            sele  ctedField={selectedFieldMultiple}
                            onSelectField={handleFieldChangeMultiple}
                          />
                        ) : selectedField === "Dealer Company" ? (
                          <DealerCompanyDropdown
                            fields={[
                              ...new Set(
                                filteredRows
                                  ?.map((row) => row?.profile?.company)
                                  .filter(Boolean)
                              ),
                            ]}
                            selectedField={selectedFieldMultiple}
                            onSelectField={handleFieldChangeMultiple}
                          />
                        ) : (
                          <SearchPanel />
                        )}
                      </div>
                    </div>
                  </DataGrid>
                ) : (
                  <div className={classes.loadingOverlay}>
                    <CircularProgress />
                  </div>
                )}
              </div>
            </Grid>
          </Grid>
        </Paper>
      </div>
    </DashboardLayout>
  );
}

DealerRequest.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default compose(withRouter, withStyles(styles))(DealerRequest);
